export default [
  {
    path: "/topology",
    component: () => import("../pages/topology/TopologyPage.vue"),
  },
];
